import axios from 'axios';

import { buildEndpoint, getAuthToken } from '../../service';
import { SubscriptionSummary } from '../../../types/subscription.type';

const BASE_URL = process.env.REACT_APP_SUBSCRIPTIONS_ADMIN_API!;

const getUserSubscriptions = async (
    userId: number
): Promise<SubscriptionSummary[] | null> => {
    try {
        const url = buildEndpoint(BASE_URL, `/users/${userId}/subscriptions`);
        const response = await axios.get(url, {
            headers: { Authorization: getAuthToken() },
        });

        return response.data;
    } catch (err) {
        console.error('Error getting user subscriptions', err);
        return null;
    }
};

export { getUserSubscriptions };
